import { render, staticRenderFns } from "./ProtocolosComponent.vue?vue&type=template&id=571a79c9&scoped=true&"
import script from "@/pages/protocolos/Protocolos.js?vue&type=script&lang=js&"
export * from "@/pages/protocolos/Protocolos.js?vue&type=script&lang=js&"
import style0 from "./ProtocolosComponent.vue?vue&type=style&index=0&id=571a79c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571a79c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VDataTable,VIcon,VTooltip})
